import { render, staticRenderFns } from "./CUInficationOrderView.vue?vue&type=template&id=7c523e21&scoped=true"
import script from "./CUInficationOrderView.vue?vue&type=script&lang=js"
export * from "./CUInficationOrderView.vue?vue&type=script&lang=js"
import style0 from "./CUInficationOrderView.vue?vue&type=style&index=0&id=7c523e21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c523e21",
  null
  
)

export default component.exports